import axios from 'axios';

const api = {
  async getBookingPortalUrl() {
    const response = await axios.get(`/billing/portal`);
    return response.data;
  },
};

export default api;
